/**
 * /shop/ filter-rail keyword search.
 *
 * Wires the two affordances around the native input:
 *   - Submit (→) and clear (×) buttons that auto-show/hide based on
 *     whether the input has typing.
 *   - Clear (×) wipes the input and (when the URL already carries
 *     ?q=) dispatches `shop:filter-change` so the cleared search
 *     immediately re-applies via the AJAX driver. Without ?q=, it
 *     just wipes locally so the user can keep typing.
 *
 * Submitting (Enter or →) is handled by the form-level submit
 * listener in shop-filter-form.js — we don't bind it here.
 */
const HIDDEN_CLASS = 'is-hidden';

const initWrap = (wrap) => {
    const input    = wrap.querySelector('.tx-shop__filter-search-input');
    const clearBtn = wrap.querySelector('.tx-shop__filter-search-clear');
    const submit   = wrap.querySelector('.tx-shop__filter-search-submit');
    const form     = wrap.closest('form');
    if (!input) return;

    const urlHasQuery = () => new URL(window.location.href).searchParams.has('q');

    const syncButtons = () => {
        const hasValue = input.value.trim().length > 0;
        submit?.classList.toggle(HIDDEN_CLASS, !hasValue);
        clearBtn?.classList.toggle(HIDDEN_CLASS, !hasValue);
    };

    input.addEventListener('input', syncButtons);

    clearBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        const wasSubmitted = urlHasQuery();
        input.value = '';
        syncButtons();
        if (wasSubmitted && form) {
            // The cleared search needs to propagate through the AJAX
            // driver so the catalog re-renders without the q= filter.
            form.dispatchEvent(new CustomEvent('shop:filter-change', { bubbles: true }));
        } else {
            input.focus();
        }
        // The product-grid block never carries ?q= in the page URL, so
        // its driver listens for this instead of shop:filter-change to
        // decide whether a committed search needs re-fetching.
        form?.dispatchEvent(new CustomEvent('shop:search-cleared', { bubbles: true }));
    });

    syncButtons();
};

const init = () => {
    document.querySelectorAll('.tx-shop__filter-search').forEach(initWrap);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
